import React from 'react'

const LoadingExpertDashboard = () => {
  return (
    <div>
        <div className='grid grid-cols-1 md:grid-cols-3 md:mt-8 mt-4 md:mx-40 mx-4'>
            <div className='col-span-1 md:col-span-2'>
            <div className='md:col-span-1 p-3 my-3 mx-4 shadow-md bg-white rounded-xl cursor-pointer'>
                <div>
                    <div className="flex justify-between items-center">
                        <div className='w-1/3 animate-pulse bg-gray-300 h-2'></div>
                        <div className='w-20 h-10 rounded-xl animate-pulse bg-gray-300'></div>
                    </div>
                    <div className='w-1/2 h-2 animate-pulse bg-gray-300'></div>
                    <div className='h-10 w-100 animate-pulse bg-gray-300 my-4 rounded-xl'></div>
                </div>
            </div>
            <div className='md:col-span-1 p-3 my-3 mx-4 shadow-md bg-white rounded-xl cursor-pointer'>
                <div>
                    <div className="flex justify-between items-center">
                        <div className='w-1/3 animate-pulse bg-gray-300 h-2'></div>
                        <div className='w-20 h-10 rounded-xl animate-pulse bg-gray-300'></div>
                    </div>
                    <div className='w-1/2 h-2 animate-pulse bg-gray-300'></div>
                    <div className='h-10 w-100 animate-pulse bg-gray-300 my-4 rounded-xl'></div>
                </div>
            </div>
            <div className='md:col-span-1 p-3 my-3 mx-4 shadow-md bg-white rounded-xl cursor-pointer'>
                <div>
                    <div className="flex justify-between items-center">
                        <div className='w-1/3 animate-pulse bg-gray-300 h-2'></div>
                        <div className='w-20 h-10 rounded-xl animate-pulse bg-gray-300'></div>
                    </div>
                    <div className='w-1/2 h-2 animate-pulse bg-gray-300'></div>
                    <div className='h-10 w-100 animate-pulse bg-gray-300 my-4 rounded-xl'></div>
                </div>
            </div>
            <div className='md:col-span-1 p-3 my-3 mx-4 shadow-md bg-white rounded-xl cursor-pointer'>
                <div>
                    <div className="flex justify-between items-center">
                        <div className='w-1/3 animate-pulse bg-gray-300 h-2'></div>
                        <div className='w-20 h-10 rounded-xl animate-pulse bg-gray-300'></div>
                    </div>
                    <div className='w-1/2 h-2 animate-pulse bg-gray-300'></div>
                    <div className='h-10 w-100 animate-pulse bg-gray-300 my-4 rounded-xl'></div>
                </div>
            </div>
            </div>
            <div className='col-span-1 gap-4 mx-8 bg:white'>
            <div className='shadow-xl rounded-md md:col-span-1 px-2 py-2 bg:white'>
                <div className='flex justify-end'><div className='w-10 h-10 bg-gray-300 mx-4 animate-pulse'></div></div>
                <div className='w-10 h-10 bg-gray-300 my-4 mx-4 animate-pulse'></div>
                <div className='w-2/3 mx-4 mb-4 animate-pulse bg-gray-300 h-2'></div>
            </div>
            <div className='shadow-xl rounded-md md:col-span-1 px-2 py-2 bg:white'>
                <div className='flex justify-end'><div className='w-10 h-10 bg-gray-300 mx-4 animate-pulse'></div></div>
                <div className='w-10 h-10 bg-gray-300 my-4 mx-4 animate-pulse'></div>
                <div className='w-2/3 mx-4 mb-4 animate-pulse bg-gray-300 h-2'></div>
            </div>
            <div className='shadow-xl rounded-md md:col-span-1 px-2 py-2 bg:white'>
                <div className='flex justify-end'><div className='w-10 h-10 bg-gray-300 mx-4 animate-pulse'></div></div>
                <div className='w-10 h-10 bg-gray-300 my-4 mx-4 animate-pulse'></div>
                <div className='w-2/3 mx-4 mb-4 animate-pulse bg-gray-300 h-2'></div>
            </div>
            <div className='shadow-xl rounded-md md:col-span-1 px-2 py-2 bg:white'>
                <div className='flex justify-end'><div className='w-10 h-10 bg-gray-300 mx-4 animate-pulse'></div></div>
                <div className='w-10 h-10 bg-gray-300 my-4 mx-4 animate-pulse'></div>
                <div className='w-2/3 mx-4 mb-4 animate-pulse bg-gray-300 h-2'></div>
            </div>
            </div>
        </div>
        {/* <div className='grid md:grid-cols-3 mx-8 my-12 bg:white'>
            
            <div className='md:col-span-1 p-3 my-3 mx-4 shadow-md bg-white rounded-xl cursor-pointer'>
                <div>
                    <div className="flex justify-between items-center">
                        <div className='w-1/3 animate-pulse bg-gray-300 h-2'></div>
                        <div className='w-20 h-10 rounded-xl animate-pulse bg-gray-300'></div>
                    </div>
                    <div className='w-1/2 h-2 animate-pulse bg-gray-300'></div>
                    <div className='h-10 w-100 animate-pulse bg-gray-300 my-4 rounded-xl'></div>
                </div>
            </div>
            <div className='md:col-span-1 p-3 my-3 mx-4 shadow-md bg-white rounded-xl cursor-pointer'>
                <div>
                    <div className="flex justify-between items-center">
                        <div className='w-1/3 animate-pulse bg-gray-300 h-2'></div>
                        <div className='w-20 h-10 rounded-xl animate-pulse bg-gray-300'></div>
                    </div>
                    <div className='w-1/2 h-2 animate-pulse bg-gray-300'></div>
                    <div className='h-10 w-100 animate-pulse bg-gray-300 my-4 rounded-xl'></div>
                </div>
            </div>
            <div className='md:col-span-1 p-3 my-3 mx-4 shadow-md bg-white rounded-xl cursor-pointer'>
                <div>
                    <div className="flex justify-between items-center">
                        <div className='w-1/3 animate-pulse bg-gray-300 h-2'></div>
                        <div className='w-20 h-10 rounded-xl animate-pulse bg-gray-300'></div>
                    </div>
                    <div className='w-1/2 h-2 animate-pulse bg-gray-300'></div>
                    <div className='h-10 w-100 animate-pulse bg-gray-300 my-4 rounded-xl'></div>
                </div>
            </div>
        </div> */}
    </div>
  )
}

export default LoadingExpertDashboard